<ng-container *ngIf="authenticationUriCd">
  <app-easy-authentication-login
    errorMessage="改めて【パスワードを忘れた方はこちら】より設定をお願いします。"
    [authenticationUriCd]="authenticationUriCd"
    (loginSuccess)="login = true"
  ></app-easy-authentication-login>
  <router-outlet *ngIf="login"></router-outlet>
</ng-container>
